export default __webpack_public_path__ + "static/media/correct-sound.02c736a3.wav";